<template>
	<div class="">
		<span  v-if="$store.state.app.token">
			<span v-if="(isAllowBuy=='1') || (isAllowBuy=='0' && price!='0')" class="flex">
				<span>￥</span>
				<span class="f-20 bold" :class="'f-'+size">{{$store.state.app.token?decimal(0)+'.':''}}</span>
				<span>{{decimal(1)}}</span>
			</span>
			<span v-else class="f-15 bold l-h-35">请线下咨询价格</span>
		</span>
		<span v-else class="f-16">价格登录后可见</span>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				// {{isAllowBuy?'':'请线下咨询价格'}}
				isAllowBuy:sessionStorage.getItem('isAllowBuy')
			}
		},
		props:['price','size'],
		
		methods:{
			decimal(k){
				this.isAllowBuy=sessionStorage.getItem('isAllowBuy')
				let price=this.price.toFixed(2)
				price=price.split('.')
				return price[k]
			}
		}
	}
</script>

<style>
</style>